(() => {
  if (window.radianPromotionInitialized) return;
  window.radianPromotionInitialized = true;

  function makeDecorative(node) {
    node.setAttribute('aria-hidden', 'true');
    node.inert = true;
    Array.from(node.attributes).forEach((attribute) => {
      if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name);
    });
    if (node.matches('a')) node.tabIndex = -1;
    return node;
  }

  function init(root) {
    if (root.dataset.promotionInitialized === 'true') return;
    const viewport = root.querySelector('[data-promotion-viewport]');
    const track = root.querySelector('[data-promotion-track]');
    const group = root.querySelector('[data-promotion-group]');
    if (!viewport || !track || !group || !group.children.length) return;

    const originals = Array.from(group.children);
    const rebuild = () => {
      group.replaceChildren(...originals);
      track.replaceChildren(group);

      let index = 0;
      while (group.scrollWidth < viewport.clientWidth * 1.5 && index < 100) {
        group.appendChild(makeDecorative(originals[index % originals.length].cloneNode(true)));
        index += 1;
      }

      const copy = group.cloneNode(true);
      copy.removeAttribute('data-promotion-group');
      makeDecorative(copy);
      copy.querySelectorAll('.promotion__item').forEach(makeDecorative);
      track.appendChild(copy);

      const secondsPer100px = Number(root.dataset.secondsPer100px) || 2;
      root.style.setProperty('--promotion-duration', `${(group.scrollWidth / 100) * secondsPer100px}s`);
      root.dataset.promotionReady = 'true';
    };

    root.dataset.promotionInitialized = 'true';
    const observer = new ResizeObserver(rebuild);
    observer.observe(viewport);
    root.promotionObserver = observer;
    rebuild();
    if (document.fonts?.ready) document.fonts.ready.then(rebuild);
  }

  function initWithin(context) {
    context.querySelectorAll('[data-promotion]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-promotion]').forEach((root) => root.promotionObserver?.disconnect());
  });
})();
